import React, { useEffect, useState, useRef } from 'react';
import baseURL from '../url';
import './Products.css';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProductosLoading from '../ProductosLoading/ProductosLoading';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import VenderAuto from '../VenderAuto/VenderAuto';
import BuscarCeroKm from '../BuscarCeroKm/BuscarCeroKm';
import PorQueElegirnos from '../PorQueElegirnos/PorQueElegirnos';
import Financiacion from '../Financiacion/Financiacion';
import Ubicacion from '../Ubicacion/Ubicacion';
import ComprarMoto from '../ComprarMoto/ComprarMoto';

SwiperCore.use([Navigation, Pagination, Autoplay]);

const PLACEHOLDER = '/placeholder-car.png';

function MarcasSection() {
    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500&display=swap');

                .marcas-wrap {
                    background: #ffffff;
                    color: #fff;
                    font-family: 'DM Sans', sans-serif;
                    overflow: hidden;
                    /* Rompe el padding del ProductsContain (10%) para ir de borde a borde */
                    margin-left: calc(-10vw + 0px);
                    margin-right: calc(-10vw + 0px);
                    margin-top: -50px;
                    /* Compensa el padding-top: 2rem del .Products */
                    margin-bottom: 0;
                    width: calc(100% + 20vw);
                }

                .marcas-hero {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    min-height: 520px;
                    position: relative;
                }

                .marcas-panel {
                    position: relative;
                    overflow: hidden;
                    cursor: pointer;
                }

                .marcas-panel::before {
                    content: '';
                    position: absolute;
                    inset: 0;
                    z-index: 1;
                    transition: opacity 0.4s;
                }

                .marcas-panel-subaru::before {
                    background: linear-gradient(135deg, rgba(0,82,204,0.85) 0%, rgba(0,0,0,0.4) 100%);
                }

                .marcas-panel-suzuki::before {
                    background: linear-gradient(225deg, rgba(200,16,46,0.85) 0%, rgba(0,0,0,0.4) 100%);
                }

                .marcas-panel:hover::before { opacity: 0.6; }

                .marcas-panel-bg {
                    position: absolute;
                    inset: 0;
                    transition: transform 0.6s ease;
                }

                .marcas-panel-subaru .marcas-panel-bg {
                    background: radial-gradient(ellipse at 30% 60%, #0052cc22 0%, transparent 60%), #111;
                }

                .marcas-panel-suzuki .marcas-panel-bg {
                    background: radial-gradient(ellipse at 70% 60%, #c8102e22 0%, transparent 60%), #111;
                }

                .marcas-panel:hover .marcas-panel-bg { transform: scale(1.04); }

                .marcas-panel-content {
                    position: relative;
                    z-index: 2;
                    padding: 48px 36px;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    box-sizing: border-box;
                }

                .marcas-tag {
                    font-size: 11px;
                    letter-spacing: 0.2em;
                    text-transform: uppercase;
                    opacity: 0.6;
                    margin-bottom: 8px;
                    color: #fff;
                }

                .marcas-name {
                    font-family: 'Nudista', sans-serif;
                    font-size: 72px;
                    font-weight: 900;
                    line-height: 1;
                    margin: 0 0 12px;
                    letter-spacing: 2px;
                }

                .marcas-panel-subaru .marcas-name { color: #4d9fff; }
                .marcas-panel-suzuki .marcas-name { color: #ff3355; }

                .marcas-tagline {
                    font-size: 14px;
                    font-weight: 300;
                    opacity: 0.75;
                    margin-bottom: 24px;
                    max-width: 220px;
                    line-height: 1.5;
                    color: #fff;
                }

                .marcas-cta {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    padding: 10px 20px;
                    border: 1px solid rgba(255,255,255,0.3);
                    font-size: 12px;
                    letter-spacing: 0.15em;
                    text-transform: uppercase;
                    cursor: pointer;
                    transition: all 0.3s;
                    background: transparent;
                    color: #fff;
                    width: fit-content;
                    text-decoration: none;
                }

                .marcas-panel-subaru .marcas-cta:hover { background: #0052cc; border-color: #0052cc; }
                .marcas-panel-suzuki .marcas-cta:hover { background: #c8102e; border-color: #c8102e; }

                .marcas-cta-arrow { transition: transform 0.3s; }
                .marcas-cta:hover .marcas-cta-arrow { transform: translateX(4px); }

                .marcas-divider {
                    position: absolute;
                    left: 50%;
                    top: 10%;
                    bottom: 10%;
                    width: 1px;
                    background: rgba(255,255,255,0.15);
                    z-index: 3;
                }

                .marcas-kanji {
                    position: absolute;
                    z-index: 2;
                    opacity: 0.18;
                    font-family: 'Bebas Neue', sans-serif;
                    font-size: 200px;
                    line-height: 1;
                    top: 50%;
                    transform: translateY(-50%);
                    pointer-events: none;
                    letter-spacing: -10px;
                }

                .marcas-panel-subaru .marcas-kanji { right: -20px; color: #4d9fff; }
                .marcas-panel-suzuki .marcas-kanji { left: -20px; color: #ff3355; }

                .marcas-models-bar {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    border-top: 1px solid rgba(255,255,255,0.06);
                }

                .marcas-model-item {
                    padding: 20px 24px;
                    border-right: 1px solid rgba(255,255,255,0.06);
                    cursor: pointer;
                    transition: background 0.25s;
                    text-decoration: none;
                }

                .marcas-model-item:last-child { border-right: none; }
                .marcas-model-item:hover { background: rgba(255,255,255,0.04); }

                .marcas-dot {
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    display: inline-block;
                    margin-bottom: 10px;
                }

                .marcas-dot-subaru { background: #4d9fff; }
                .marcas-dot-suzuki { background: #ff3355; }

                .marcas-model-name {
                    font-family: 'Bebas Neue', sans-serif;
                    font-size: 22px;
                    letter-spacing: 1px;
                    color: #fff;
                    margin-bottom: 3px;
                }

                .marcas-model-desc {
                    font-size: 11px;
                    color: rgba(255,255,255,0.4);
                    letter-spacing: 0.05em;
                }

                .marcas-model-price {
                    font-size: 12px;
                    color: rgba(255,255,255,0.6);
                    margin-top: 8px;
                    font-weight: 500;
                }

                .marcas-bottom-strip {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 16px 36px;
                    border-top: 1px solid rgba(255,255,255,0.06);
                    background: rgba(255,255,255,0.02);
                    flex-wrap: wrap;
                    gap: 12px;
                }

                .marcas-strip-text {
                    font-size: 11px;
                    color: rgba(255,255,255,0.35);
                    letter-spacing: 0.12em;
                    text-transform: uppercase;
                }

                .marcas-strip-badges {
                    display: flex;
                    gap: 16px;
                    flex-wrap: wrap;
                }

                .marcas-badge {
                    font-size: 10px;
                    letter-spacing: 0.15em;
                    text-transform: uppercase;
                    padding: 5px 12px;
                    border: 1px solid rgba(255,255,255,0.12);
                    color: rgba(255,255,255,0.5);
                }

                .marcas-badge-red {
                    border-color: #ff3355;
                    color: #ff3355;
                }

                @media (max-width: 700px) {
                    .marcas-wrap {
                        /* Compensa el padding del móvil (aprox 2-4%) */
                        margin-left: -4vw;
                        margin-right: -4vw;
                        width: calc(100% + 8vw);
                        margin-top: -50px;
                    }
                    .marcas-hero { grid-template-columns: 1fr; }
                    .marcas-panel-subaru,
                    .marcas-panel-suzuki { min-height: 280px; }
                    .marcas-name { font-size: 52px; }
                    .marcas-models-bar { grid-template-columns: repeat(2, 1fr); }
                    .marcas-divider { display: none; }
                    .marcas-kanji { font-size: 130px; }
                    .marcas-panel-content { padding: 32px 24px; }
                }
            `}</style>

        </>
    );
}

export default function Products() {
    const [categorias, setCategorias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fixedCategories, setFixedCategories] = useState(false);
    const categoriasRefs = useRef([]);
    const categoriasInputRef = useRef(null);
    const [productos, setProductos] = useState([]);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('Destacados');

    const handleClickCategoria = (categoria) => {
        setCategoriaSeleccionada(categoria);
    };

    useEffect(() => {
        cargarProductos();
        cargarCategorias();

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleScroll = () => {
        if (categoriasInputRef.current) {
            if (window.scrollY > categoriasInputRef.current.offsetTop) {
                setFixedCategories(true);
            } else {
                setFixedCategories(false);
            }
        }
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const lista =
                    data.productos ||
                    data.items ||
                    data.data ||
                    (Array.isArray(data) ? data : []);
                setProductos(lista);
                setLoading(false);

                if (lista.length > 0) {
                    console.log('[Products] Primer producto:', lista[0]);
                }
            })
            .catch(error => {
                console.error('Error al cargar productos:', error);
                setLoading(false);
            });
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const obtenerImagen = (item) => {
        if (!item) return PLACEHOLDER;
        return (
            item.imagen1 ||
            item.imagen2 ||
            item.imagen3 ||
            item.imagen4 ||
            item.imagen5 ||
            PLACEHOLDER
        );
    };

    const categoriasConProductos = categorias.filter(categoria =>
        productos?.some(producto => producto?.idCategoria === categoria?.idCategoria)
    );

    return (
        <>


            <BuscarCeroKm />
            <ComprarMoto />
            <Financiacion />
            <Ubicacion />
        </>
    );
}